import dvr from 'mobx-react-form/lib/validators/DVR';
import vjf from 'mobx-react-form/lib/validators/VJF';
import validatorjs from 'validatorjs';
import MobxReactForm, { Form } from 'mobx-react-form';
import { FormEvent } from 'react';
import { reaction } from 'mobx';

function getFormValidation(
  fields: any,
  options?: {
    successHandler?: (form: FormEvent) => void;
    errorHandler?: () => void;
    isNested?: boolean;
  }
): Form {
  const hooks: any = {};
  const updatedFields: any = options?.isNested ? fields : { fields };

  const plugins: any = {
    dvr: dvr({
      package: validatorjs,
      extend: ({ validator, form }) => {
        const messages = validator.getMessages('en');
        messages.required_if = 'The :attribute is Required!';
        // validatorjs' default ("The :attribute format is invalid.") reads as "The Email format is
        // invalid." and disagrees with the message already used on the shared-mailbox and invoice
        // email fields elsewhere in the wizard (bug 5849).
        messages.email = 'Enter a valid email address.';
        validator.setMessages('en', messages);
      },
    }),
    vjf: vjf(),
  };

  const formOptions: any = { validateOnChange: true };

  if (options?.successHandler) {
    hooks.onSuccess = options?.successHandler;
  }

  if (options?.errorHandler) {
    hooks.onError = options?.errorHandler;
  }

  hooks.onInit = (form: MobxReactForm) => {
    reaction(
      () => form.values(),
      () => {
        // form.validate() defaults to showErrors:false, and it revalidates every field, not just the
        // one that changed. mobx-react-form's own Validator applies that flag to every field it
        // touches, so editing one field (e.g. opening the Imperans Role dropdown) silently hid the
        // error already showing on an untouched, still-invalid Email field — it only came back on the
        // next submit attempt (bug 5850). Snapshot which fields are currently showing an error and
        // restore just those, so this revalidation can still refresh isValid/errorSync for every
        // field without hiding an error the user is already looking at, or revealing one on a field
        // nobody has touched yet.
        const shown = new Set<string>();
        form.each((field: any) => field.showError && shown.add(field.path));
        form.validate().then(() => {
          form.each((field: any) => shown.has(field.path) && field.showErrors(true, false));
        });
      }
    );
  };

  return new MobxReactForm(updatedFields, {
    plugins,
    hooks,
    options: formOptions,
  });
}

export { getFormValidation };
